module.exports = __webpack_public_path__ + "28db9e46bcab3f329eebbf9721879937.svg";